import React from "react";
import { useSearchParams } from "react-router-dom";
import axios from "axios";
import { styled } from "@mui/material/styles";
import {
  Container,
  Grid,
  TextField,
  Button,
  InputLabel,
  MenuItem,
  FormControl,
  Select,
  ListSubheader,
  Dialog,
  DialogActions,
  DialogContent,
} from "@mui/material";

const Entry = ({
  open,
  entry,
  tasks,
  projects,
  registeredHours,
  week,
  handleClose,
}) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [project, setProject] = React.useState("");
  const [task, setTask] = React.useState("");
  const [workCode, setWorkCode] = React.useState("DV");
  const [description, setDescription] = React.useState("");
  const [mondayHours, setMondayHours] = React.useState("");
  const [tuesdayHours, setTuesdayHours] = React.useState("");
  const [wednesdayHours, setWednesdayHours] = React.useState("");
  const [thursdayHours, setThursdayHours] = React.useState("");
  const [fridayHours, setFridayHours] = React.useState("");
  const [saturdayHours, setSaturdayHours] = React.useState("");
  const [sundayHours, setSundayHours] = React.useState("");

  const [editMode, setEditMode] = React.useState(false);

  if (entry) {
    if (!editMode) {
      console.log(entry);
      entry.workCode &&
        entry.workCode !== workCode &&
        setWorkCode(entry.workCode);
      if (entry.description && entry.description !== description) {
        setDescription(entry.description);
      }
      if (entry.projectId) {
        setProject(entry.projectId);
      }
      if (entry.taskID) {
        setTask(entry.taskID);
      }

      if (entry.registeredHours) {
        entry.registeredHours.monday !== mondayHours &&
          setMondayHours(entry.registeredHours.monday);
        entry.registeredHours.tuesday !== tuesdayHours &&
          setTuesdayHours(entry.registeredHours.tuesday);
        entry.registeredHours.wednesday !== wednesdayHours &&
          setWednesdayHours(entry.registeredHours.wednesday);
        entry.registeredHours.thursday !== thursdayHours &&
          setThursdayHours(entry.registeredHours.thursday);
        entry.registeredHours.friday !== fridayHours &&
          setFridayHours(entry.registeredHours.friday);
        entry.registeredHours.saturday !== saturdayHours &&
          setSaturdayHours(entry.registeredHours.saturday);
        entry.registeredHours.sunday !== sundayHours &&
          setSundayHours(entry.registeredHours.sunday);
      }
      setEditMode(true);
    }
  }

  const handleAddEntry = (event) => {
    if (!editMode) {
      axios
        .post("/api/addNewEntryToTimesheet", {
          timesheetId: searchParams.get("id"),
        })
        .then(function (response) {
          let lines = response.data.data.lines;
          let newestId = Math.max(...lines.map((item) => item.id));
          let newestLine = lines.filter((item) => item.id === newestId);
          newestLine[0].projectID = project;
          newestLine[0].taskID = task;
          newestLine[0].workCodeID = workCode;
          newestLine[0].description = description;

          if (Number(mondayHours) && Number(mondayHours) > 0) {
            newestLine[0].mon = Number(mondayHours);
          }
          if (Number(tuesdayHours) && Number(tuesdayHours) > 0) {
            newestLine[0].tue = Number(tuesdayHours);
          }
          if (Number(wednesdayHours) && Number(wednesdayHours) > 0) {
            newestLine[0].wed = Number(wednesdayHours);
          }
          if (Number(thursdayHours) && Number(thursdayHours) > 0) {
            newestLine[0].thu = Number(thursdayHours);
          }
          if (Number(fridayHours) && Number(fridayHours) > 0) {
            newestLine[0].fri = Number(fridayHours);
          }
          if (Number(saturdayHours) && Number(saturdayHours) > 0) {
            newestLine[0].sat = Number(saturdayHours);
          }
          if (Number(sundayHours) && Number(sundayHours) > 0) {
            newestLine[0].sun = Number(sundayHours);
          }
          axios.put("/api/updateTimesheetEntry", newestLine).then((resp) => {
            window.location.reload();
          });
        })
        .catch(function (error) {
          console.log(error);
        });
    } else {
      let obj = [
        {
          id: entry.lineId,
          timeSheetID: Number(searchParams.get("id")),
        },
      ];

      obj[0].projectID = project;
      obj[0].taskID = task;
      obj[0].workCodeID = workCode;
      obj[0].description = description;

      if (Number(mondayHours) && Number(mondayHours) > 0) {
        obj[0].mon = Number(mondayHours);
      }
      if (Number(tuesdayHours) && Number(tuesdayHours) > 0) {
        obj[0].tue = Number(tuesdayHours);
      }
      if (Number(wednesdayHours) && Number(wednesdayHours) > 0) {
        obj[0].wed = Number(wednesdayHours);
      }
      if (Number(thursdayHours) && Number(thursdayHours) > 0) {
        obj[0].thu = Number(thursdayHours);
      }
      if (Number(fridayHours) && Number(fridayHours) > 0) {
        obj[0].fri = Number(fridayHours);
      }
      if (Number(saturdayHours) && Number(saturdayHours) > 0) {
        obj[0].sat = Number(saturdayHours);
      }
      if (Number(sundayHours) && Number(sundayHours) > 0) {
        obj[0].sun = Number(sundayHours);
      }
      axios.put("/api/updateTimesheetEntry", obj).then((resp) => {
        window.location.reload();
      });
    }
    handleClose();
  };

  const closeModal = () => {
    setProject("");
    setTask("");
    setWorkCode("DV");
    setDescription("");
    setMondayHours("");
    setTuesdayHours("");
    setWednesdayHours("");
    setThursdayHours("");
    setFridayHours("");
    setSaturdayHours("");
    setSundayHours("");
    setEditMode(false);
    handleClose();
  };

  let isButtonDisabled = () => {
    if (["HR9100", "HR9110", "HR9120", "HR9130"].includes(project)) {
      return (
        project.length === 0 ||
        description.length === 0 ||
        (mondayHours.length === 0 &&
          tuesdayHours.length === 0 &&
          wednesdayHours.length === 0 &&
          thursdayHours.length === 0 &&
          fridayHours.length === 0 &&
          saturdayHours.length === 0 &&
          sundayHours.length === 0)
      );
    } else {
      return (
        project.length === 0 ||
        description.length === 0 ||
        task.length === 0 ||
        workCode.length === 0 ||
        (mondayHours.length === 0 &&
          tuesdayHours.length === 0 &&
          wednesdayHours.length === 0 &&
          thursdayHours.length === 0 &&
          fridayHours.length === 0 &&
          saturdayHours.length === 0 &&
          sundayHours.length === 0)
      );
    }
  };
  return (
    <Dialog open={open} onClose={closeModal} fullScreen>
      <DialogContent>
        <hr
          className="hr-text"
          data-content={`Registered hours for week ${week.weekNo}`}
        ></hr>
        <table
          style={{
            textAlign: "center",
            margin: "0 auto",
            borderSpacing: "11px 0",
          }}
        >
          <thead>
            <tr>
              {week.showMon && <th style={{ color: week.isWorkingMon ? "rgba(0, 0, 0, 0.87)": "red"}}>Mon</th>}
              {week.showTue && <th style={{ color: week.isWorkingTue ? "rgba(0, 0, 0, 0.87)": "red"}}>Tue</th>}
              {week.showWed && <th style={{ color: week.isWorkingWed ? "rgba(0, 0, 0, 0.87)": "red"}}>Wed</th>}
              {week.showThu && <th style={{ color: week.isWorkingThu ? "rgba(0, 0, 0, 0.87)": "red"}}>Thu</th>}
              {week.showFri && <th style={{ color: week.isWorkingFri ? "rgba(0, 0, 0, 0.87)": "red"}}>Fri</th>}
              {week.showSat && <th style={{ color: "red" }}>Sat</th>}
              {week.showSun && <th style={{ color: "red" }}>Sun</th>}
            </tr>
          </thead>
          <tbody>
            <tr>
              {week.showMon && (
                <td>
                  {registeredHours && registeredHours.monday
                    ? mondayHours
                    : 0}
                </td>
              )}
              {week.showTue && (
                <td>
                  {registeredHours && registeredHours.tuesday
                    ? tuesdayHours
                    : 0}
                </td>
              )}
              {week.showWed && (
                <td>
                  {registeredHours && registeredHours.wednesday
                    ? wednesdayHours
                    : 0}
                </td>
              )}
              {week.showThu && (
                <td>
                  {registeredHours && registeredHours.thursday
                    ? thursdayHours
                    : 0}
                </td>
              )}
              {week.showFri && (
                <td>
                  {registeredHours && registeredHours.friday
                    ? fridayHours
                    : 0}
                </td>
              )}
              {week.showSat && (
                <td
                  style={{
                    color:
                      registeredHours.saturday && registeredHours.saturday > 0
                        ? "red"
                        : "black",
                  }}
                >
                  {registeredHours && registeredHours.saturday
                    ? saturdayHours
                    : 0}
                </td>
              )}
              {week.showSun && (
                <td
                  style={{
                    color:
                      registeredHours.sunday && registeredHours.sunday > 0
                        ? "red"
                        : "black",
                  }}
                >
                  {registeredHours && registeredHours.sunday
                    ? sundayHours
                    : 0}
                </td>
              )}
            </tr>
          </tbody>
        </table>
        <Container maxWidth="md">
          <Grid container direction="column" spacing={8}>
            <Grid item>
              <hr
                className="hr-text"
                data-content={`${week.period} (week ${week.weekNo})`}
              ></hr>
              <FormControl
                variant="outlined"
                fullWidth
                margin="dense"
                size="small"
              >
                <InputLabel>Project</InputLabel>
                <Select
                  value={project}
                  onChange={(event) => setProject(event.target.value)}
                  label="Project"
                >
                  <ListSubheader>
                    <hr
                      className="hr-text"
                      data-content="Absence categories"
                    ></hr>
                  </ListSubheader>
                  {projects.map((project, i) => {
                    if (project.id) {
                      return (
                        <MenuItem key={project.id} value={project.id}>
                          {project.name} ({project.id})
                        </MenuItem>
                      );
                    } else if (!project.id && i > 0) {
                      return (
                        <ListSubheader key={i}>
                          <hr
                            className="hr-text"
                            data-content="Work categories"
                          ></hr>
                        </ListSubheader>
                      );
                    }
                  })}
                </Select>
              </FormControl>
              {!["HR9100", "HR9110", "HR9120", "HR9130"].includes(project) && (
                <>
                  <FormControl
                    variant="outlined"
                    fullWidth
                    margin="dense"
                    size="small"
                  >
                    <InputLabel>Task</InputLabel>
                    {}
                    <Select
                      value={task}
                      onChange={(event) => setTask(event.target.value)}
                      label="Task"
                    >
                      {tasks.map((task, i) => {
                        if (task.id) {
                          return (
                            <MenuItem key={task.id} value={task.id}>
                              {task.name} ({task.id})
                            </MenuItem>
                          );
                        }
                      })}
                    </Select>
                  </FormControl>
                  <FormControl
                    variant="outlined"
                    fullWidth
                    margin="dense"
                    size="small"
                  >
                    <InputLabel>Work code</InputLabel>
                    <Select
                      value={workCode}
                      onChange={(event) => setWorkCode(event.target.value)}
                      label="Work code"
                    >
                      <MenuItem value={"DV"}>DV (regular work)</MenuItem>
                      <MenuItem value={"YV"}>YV (overtime)</MenuItem>
                      <MenuItem value={"VA"}>VA (shift work)</MenuItem>
                    </Select>
                  </FormControl>
                </>
              )}

              <TextField
                margin="dense"
                id="outlined-textarea"
                label="Description"
                style={{ marginBottom: 15 }}
                fullWidth
                placeholder="Write description here"
                value={description}
                onChange={(event) => setDescription(event.target.value)}
                multiline
                rows={2}
                variant="outlined"
              />
              <hr
                className="hr-text"
                data-content="Fill out hours for project"
              ></hr>

              {week.showMon && (
                <TextField
                  onFocus={(event) => {
                    event.target.select();
                  }}
                  size="small"
                  value={mondayHours}
                  onChange={(event) => setMondayHours(event.target.value)}
                  label="Monday"
                  type="number"
                  variant="outlined"
                  style={{ width: "45%", marginRight: "10%", marginBottom: 15 }}
                />
              )}
              {week.showTue && (
                <TextField
                  onFocus={(event) => {
                    event.target.select();
                  }}
                  size="small"
                  value={tuesdayHours}
                  onChange={(event) => setTuesdayHours(event.target.value)}
                  label="Tuesday"
                  type="number"
                  variant="outlined"
                  style={{
                    width: "45%",
                    marginBottom: 15,
                    marginRight: week.showMon ? 0 : "10%",
                  }}
                />
              )}
              {week.showWed && (
                <TextField
                  onFocus={(event) => {
                    event.target.select();
                  }}
                  size="small"
                  value={wednesdayHours}
                  onChange={(event) => setWednesdayHours(event.target.value)}
                  label="Wednesday"
                  type="number"
                  variant="outlined"
                  style={{
                    width: "45%",
                    marginBottom: 15,
                    marginRight:
                      [week.showMon, week.showTue, week.showWed].filter(
                        (x) => x === true
                      ).length %
                        2 ===
                      0
                        ? 0
                        : "10%",
                  }}
                />
              )}
              {week.showThu && (
                <TextField
                  onFocus={(event) => {
                    event.target.select();
                  }}
                  size="small"
                  value={thursdayHours}
                  onChange={(event) => setThursdayHours(event.target.value)}
                  label="Thursday"
                  type="number"
                  variant="outlined"
                  style={{
                    width: "45%",
                    marginBottom: 15,
                    marginRight:
                      [
                        week.showMon,
                        week.showTue,
                        week.showWed,
                        week.showThu,
                      ].filter((x) => x === true).length %
                        2 ===
                      0
                        ? 0
                        : "10%",
                  }}
                />
              )}
              {week.showFri && (
                <TextField
                  onFocus={(event) => {
                    event.target.select();
                  }}
                  size="small"
                  value={fridayHours}
                  onChange={(event) => setFridayHours(event.target.value)}
                  label="Friday"
                  type="number"
                  variant="outlined"
                  style={{
                    width: "45%",
                    marginBottom: 15,
                    marginRight:
                      [
                        week.showMon,
                        week.showTue,
                        week.showWed,
                        week.showThu,
                        week.showFri,
                      ].filter((x) => x === true).length %
                        2 ===
                      0
                        ? 0
                        : "10%",
                  }}
                />
              )}
              {week.showSat && (
                <TextField
                  onFocus={(event) => {
                    event.target.select();
                  }}
                  size="small"
                  color="error"
                  value={saturdayHours}
                  onChange={(event) => setSaturdayHours(event.target.value)}
                  label="Saturday"
                  type="number"
                  variant="outlined"
                  style={{
                    width: "45%",
                    marginBottom: 15,
                    marginRight:
                      [
                        week.showMon,
                        week.showTue,
                        week.showWed,
                        week.showThu,
                        week.showFri,
                        week.showSat,
                      ].filter((x) => x === true).length %
                        2 ===
                      0
                        ? 0
                        : "10%",
                  }}
                />
              )}
              {week.showSun && (
                <TextField
                  onFocus={(event) => {
                    event.target.select();
                  }}
                  size="small"
                  color="error"
                  value={sundayHours}
                  onChange={(event) => setSundayHours(event.target.value)}
                  label="Sunday"
                  type="number"
                  variant="outlined"
                  style={{ width: "45%", marginBottom: 15 }}
                />
              )}
            </Grid>
          </Grid>
        </Container>
      </DialogContent>
      <DialogActions>
        <Button
          variant="outlined"
          onClick={closeModal}
          style={{
            height: 60,
            color: "rgb(172, 5, 51)",
            width: "40%",
            marginRight: "5%",
            maxWidth: "300px",
          }}
        >
          Cancel
        </Button>
        <Button
          style={{
            height: 60,
            width: "43%",
            maxWidth: "300px",
            marginRight: "5%",
          }}
          variant="outlined"
          onClick={handleAddEntry}
          disabled={isButtonDisabled()}
        >
          {editMode ? "Save" : "Add Entry"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default Entry;
